import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import {
  selectSubscriptionIntervalType,
  selectSubscriptionPackageType,
  setSubscriptionIntervalType,
  setSubscriptionPackageType,
} from '~/redux/slices/subscription.slice'

type subscriptionToggleType = 'family' | 'individual'
type subscriptionIntervalType = 'month' | 'year'

export default function useSubscriptionToggle(): {
  subscriptionType: subscriptionToggleType
  updateSubscriptionPackageType: (packageType: subscriptionToggleType) => void
  subscriptionIntervalType: subscriptionIntervalType
  updateSubscriptionIntervalType: (intervalType: subscriptionIntervalType) => void
} {
  const dispatch = useAppDispatch()

  const updateSubscriptionPackageType = (packageType: subscriptionToggleType): void => {
    dispatch(setSubscriptionPackageType(packageType))
  }

  const updateSubscriptionIntervalType = (intervalType: subscriptionIntervalType): void => {
    dispatch(setSubscriptionIntervalType(intervalType))
  }

  const subscriptionType = useAppSelector(selectSubscriptionPackageType)
  const subscriptionIntervalType = useAppSelector(selectSubscriptionIntervalType)

  return {
    subscriptionType: subscriptionType ?? 'family',
    updateSubscriptionPackageType,
    subscriptionIntervalType: subscriptionIntervalType ?? 'year',
    updateSubscriptionIntervalType,
  }
}
